import { Injectable } from '@angular/core';
import { Product } from 'src/app/shared/interface';
import { DataService } from '../data/data.service';
import { FunctionsService } from '../functions/functions.service';
import { Storage } from '@ionic/storage-angular';
import { BehaviorSubject, Observable } from 'rxjs';
import { AlertController } from '@ionic/angular';
const CART = 'cart';
interface BalanceGroup {_id:string, balance:number,price:number,status:number};

@Injectable({
  providedIn: 'root'
})
export class CartService {
  cart: any [] = [];
  private balance:boolean = this.dataService.settings.balance;


  private count:BehaviorSubject<number> = new BehaviorSubject(0);
  constructor(
    private dataService:DataService,
    private functionsService:FunctionsService,
    private storage:Storage,
    private alertCtrl:AlertController

  ) {
  }


  async reloadCart():Promise<void> {
    const cart:any[] = await this.storage.get(CART)
    this.cart = cart ? cart : []
    this.count.next(this.cart.length);
  }

  reloadSettings():void {
    this.balance = this.dataService.settings.balance
  }

  get cartCount ():Observable<number> {
    return this.count.asObservable();
  }

  async updateCart(item:any) {
    // check if product has items;
    if(item?.additions?.length) return await this.updateItemWithAdditions(item)

    // check if item found
    let filter = this.cart.filter(p => p._id == item._id);
    if (filter.length) {
      if(item.QTY){
        filter[0].QTY = item.QTY;
        filter[0].selectedItems = item?.selectedItems
        filter[0].selectedAdditions = []
      } else {
        // remove if QTY = 0
        this.cart = this.cart.filter(p => p._id !== item._id)
      }
    }
    else{
      this.cart.push(item);
    }
    this.saveCart()
  }


  async updateItemWithAdditions(product:any):Promise<void> {

    const items = this.cart.filter(p => p?.productId == product?.productId);
    // item exist then update it
    if(items?.length) {
      if(product.QTY) {
        items[0].selectedAdditions = product?.selectedAdditions;
        items[0].QTY = product.QTY;
        items[0].note = product.note
      }else{
        this.cart = this.cart.filter(p => p.productId !== product.productId)
      }
    }else{
      this.cart.push(product)
    };

    console.log(this.cart);
    console.log(product.QTY);


    await this.saveCart()
  };


  getItemWithAdditionsBalance(product:any) {
    const items = this.cart.filter(p => p?._id == product?._id);
    if(items.length) return items.reduce((i,j) => j.QTY + i, 0)
    return 0;
  }

  getItemWithPureAdditionsBalance(product:any):number {
    const items = this.cart.filter(p => p?._id == product?._id && !p.additionId && !p.subAdditionId );
    if(items.length) return items.reduce((i,j) => j.QTY + i, 0)
    return 0;
  }

  getItemWithAdditionsBalanceByAddition(product:any,addition:any) {
    const items = this.cart.filter(p => p?._id == product?._id && p.additionId == addition?._id);
    if(items.length) return items.reduce((i,j) => j.QTY + i, 0)
    return 0;
  }

  getItemWithAdditionsBalanceBySubAddition(product:any,subAddition:any) {
    const items = this.cart.filter(p => p?._id == product?._id && p.subAdditionId  == subAddition?._id);
    if(items.length) return items.reduce((i,j) => j.QTY + i, 0)
    return 0;
  }



  getItemCartWithAdditions(item:any) {
    let filter = this.cart.filter(p => p.productId == item?.productId);

    if(filter[0]) {
      if(this.balance) {
        item.QTY = filter[0].QTY > item?.availableBalance  ? item?.availableBalance  : filter[0].QTY;
      }else {
        item.QTY = filter[0].QTY
      }
      item.selectedItems = []
      item.selectedAdditions = filter[0]?.selectedAdditions || []
      item.note = filter[0].note,
      item.subAdditionId = filter[0]?.subAdditionId;
      item.additionId = filter[0]?.additionId;
    }else{
      item.QTY = 0;
      item.selectedItems = []
      item.selectedAdditions = []
      item.note = "";
      // item.subAdditionId = null;
      // item.additionId = null;
    }
  }


  async deleteProduce(product:Product):Promise<void> {
    if(product?.additions?.length) {
      this.cart = this.cart.filter(p => p.productId != product.productId);
    }else{
      this.cart = this.cart.filter(p => p._id != product._id);
    }
    await this.saveCart();
  }

  async updateProducePure(product:Product,balance:number):Promise<void> {
    const pureProducts = this.cart.filter(p => p._id == product._id && !p.additionId && !p.subAdditionId);
    let stockShortage = balance;
    for(let p of pureProducts) {
      p.QTY = p.QTY + stockShortage;
      if(p.QTY <= 0) {
        stockShortage = stockShortage + p.QTY;
        this.deleteProduce(p);
        continue
      }
      break;
    }

    await this.saveCart();
  }

  async updateProduceAddition(product:Product,addition:any,balance:number):Promise<void> {
    const pureProducts = this.cart.filter(p => p._id == product._id && p.additionId == addition._id);
    let stockShortage = balance;
    for(let p of pureProducts) {
      p.QTY = p.QTY + stockShortage;
      if(p.QTY <= 0) {
        stockShortage = stockShortage + p.QTY;
        this.deleteProduce(p);
        continue
      }
      break;
    }

    await this.saveCart();
  }

  async updateProduceSubAddition(product:Product, subAddition:any,balance:number):Promise<void> {
    const pureProducts = this.cart.filter(p => p._id == product._id && p.subAdditionId == subAddition._id);
    let stockShortage = balance;
    for(let p of pureProducts) {
      p.QTY = p.QTY + stockShortage;
      if(p.QTY <= 0) {
        stockShortage = stockShortage + p.QTY;
        this.deleteProduce(p);
        continue
      }
      break;
    }

    await this.saveCart();
  }

  async saveCart() {
    await this.storage.set(CART , this.cart);
    // await this.reloadCart();
    this.count.next(this.cart.length);
  }


  getItemCart(item:Product) {
    let filter = this.cart.filter(p => p._id == item._id);
    if(!filter.length) {
      item.QTY = 0;
      return
    }

    // if(filter[0]) {
      item.QTY = filter[0].QTY <= (this.balance && item?.balance && filter[0].QTY > item?.balance) ? item?.balance  : filter[0].QTY;
      // item.selectedItems = filter[0]?.selectedItems || []
    // }
  };


  async clearCart():Promise<void> {
    this.cart = [];
    await this.saveCart();
  }

  // get total():number {

  //   const privatePrice:boolean = this.dataService.privatePrice
  //   let total  = this.cart.reduce((i, j) => j.QTY * (j?.discountPrice ? j?.discountPrice : (privatePrice? j.privatePrice: j.price)) + i, 0)
  //   for (let product of this.cart) {
  //     if(!product?.selectedAdditions?.length) continue
  //     total +=  product?.selectedAdditions?.reduce((i,j) => (j?.price + (j?.subAdditions?.price || 0)) + i, 0) * product?.QTY || 0
  //   }

  //   return total || 0
  // }

  get total():number {
    let total = this.cart.reduce((i, j) => j.QTY * j?.finalPrice + i, 0);
    for (let product of this.cart) {
      if(!product?.selectedAdditions?.length) continue
      total +=  product?.selectedAdditions?.reduce((i,j) => (j?.price + (j?.subAdditions?.price || 0)) + i, 0) * product?.QTY || 0
    }
    return total || 0
  }




  // check totalBalance;

  async checkBalance():Promise<string[]> {
    this.balance = this.dataService.settings.balance;

    await this.functionsService.showLoading();
    let messages = []
    return new Promise(async (resolve) => {
      this.dataService.postData(`/product/balance-group`,{data:this.groupBody})
        .subscribe({
          next:async (res:{additions:BalanceGroup[],products:BalanceGroup[],subAdditions:BalanceGroup[],}) => {
              const productMessages = this.updateProductBalance(res.products)
              const additionMessages =this.updateAdditionBalance(res.additions)
              const subAdditionMessages =this.updateSubAdditionsBalance(res.subAdditions)
              messages = messages.concat(productMessages,additionMessages,subAdditionMessages)
              await this.functionsService.dismissLoading();
              resolve(messages)
          },
          error:async (err) => {
            await this.functionsService.dismissLoading();
            resolve([]);
          }
        })
      return true;
    })
  }


  private get groupBody():BalanceGroup[]{
    let products = []
    for(let product of this.cart) {
      const exist = products.find(p => (p.addition == product.additionId && p.additionId != null) || (p.subAddition == product.subAdditionId &&  p.additionId != null))
      if(exist) continue
      products.push({
        product:product._id,
        addition:product.additionId,
        subAddition:product.subAdditionId,
      });
    }
    return products;
  }


  private updateProductBalance(balances:BalanceGroup[]):string[] {
    let newBalance:BalanceGroup = null;
    let messages = []
    for(let product of this.cart) {
      newBalance = balances.find(b => b._id == product._id);
      if(!newBalance) continue;
      product.finalPrice = newBalance.price;
      if(!newBalance.status) {
        product.status = newBalance.status;
        product.QTY = 0;
        continue
      }
      console.log(this.balance);

      if(!this.balance) continue
      if(product.additions?.length) {
        const availableBalance = newBalance.balance - this.getItemWithPureAdditionsBalance(product);
        console.log(availableBalance);

        product.balance = newBalance.balance;
        product.availableBalance = newBalance.balance;
        // product.finalPrice = newBalance.price;
        if(availableBalance < 0) {
          product.QTY = product.QTY + availableBalance > 0 ? product.QTY + availableBalance : 0;
          const message = product.QTY ? `لا يوجد سوى ${product.QTY} من المنتج ${product.name}` : `نفذت كمية المنتج ${product.name}`
          messages.push(message);
        }

        continue;
      }


      product.balance = newBalance.balance;
      product.availableBalance = newBalance.balance;
      product.finalPrice = newBalance.price;


      if(product.QTY > product.balance){
        product.QTY = product.balance;
        const message = product.QTY ? `لا يوجد سوى ${product.QTY} من المنتج ${product.name}` : `نفذت كمية المنتج ${product.name}`
        messages.push(message);
      }

    };
    this.cart = this.cart.filter(p => p.QTY > 0);
    this.saveCart();
    return messages;
  }

  private updateAdditionBalance(balances:BalanceGroup[]):string[] {
    let newBalance:BalanceGroup = null;
    let messages = []
    for(let product of this.cart) {
      newBalance = balances.find(b => b._id == product.additionId);
      if(!newBalance) continue;
      product.selectedAdditions[0].price = newBalance.price;
      if(!newBalance.status) {
        product.selectedAdditions[0].status = newBalance.status;
        product.QTY = 0;
        continue
      }
      if(!this.balance) continue
        const availableBalance = newBalance.balance - this.getItemWithAdditionsBalanceByAddition(product,product?.selectedAdditions[0]);
        product.balance = newBalance.balance;
        product.availableBalance = newBalance.balance;
        product.selectedAdditions[0].price = newBalance.price;
        if(availableBalance < 0) {
          product.QTY = product.QTY + availableBalance > 0 ? product.QTY + availableBalance : 0;
          const message = product.QTY ? `لا يوجد سوى ${product.QTY} من المنتج ${product.name}` : `نفذت كمية المنتج ${product.name}`
          messages.push(message);
        }

    };

    this.cart = this.cart.filter(p => p.QTY > 0);
    this.saveCart();
    return messages;
  }


  private updateSubAdditionsBalance(balances:BalanceGroup[]):string[]{
    let newBalance:BalanceGroup = null;
    let messages = []
    for(let product of this.cart) {
      newBalance = balances.find(b => b._id == product.subAdditionId);
      if(!newBalance) continue;
      product.selectedAdditions[0].subAdditions.price = newBalance.price;
      if(!newBalance.status) {
        product.selectedAdditions[0].subAdditions.status = newBalance.status;
        product.QTY = 0;
        continue
      }
      if(!this.balance) continue
      // if(product.subAdditionId == newBalance._id) {
        const availableBalance = newBalance.balance - this.getItemWithAdditionsBalanceBySubAddition(product,product.subAdditionId);
        product.selectedAdditions[0].subAdditions.balance = newBalance.balance;
        product.availableBalance = newBalance.balance;
        product.selectedAdditions[0].subAdditions.price = newBalance.price;
        if(availableBalance < 0) {
          product.QTY = product.QTY + availableBalance > 0 ? product.QTY + availableBalance : 0;
          const message = product.QTY ? `لا يوجد سوى ${product.QTY} من المنتج ${product.name}` : `نفذت كمية المنتج ${product.name}`
          messages.push(message);
        }
      // }
    };

    this.cart = this.cart.filter(p => p.QTY > 0);
    this.saveCart();
    return messages;
  }


  async showAlert(messages:string[]):Promise<void> {
    const alert = await this.alertCtrl.create({
      header:"تحديث كمية المنتجات",
      message:messages.join(`\n`),
      mode:"ios",
      buttons:[
        {
          "text":"الغاء",
          role:"cancel"
        }
      ]
    });
    await alert.present();
    await alert.onDidDismiss();
  }

}
